import { render, staticRenderFns } from "./GuestCoverImage.vue?vue&type=template&id=8556a5fc"
import script from "./GuestCoverImage.vue?vue&type=script&lang=js"
export * from "./GuestCoverImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports